import React from 'react';
import styled from 'styled-components';

import { Icon, Switch, Text, Title } from 'components';
import { useContactState } from './hooks';

const MultiConfListing: React.FC = () => {
  const [contactState, updateContactState] = useContactState();

  return (
    <StyledContainer>
      <Title level={2}>
        <Icon type="antdWarningOutlined" color="purple5" offset={[0, -4]} />{' '}
        Multi-conf Listing
      </Title>
      <StyledSwitchContainer>
        <Switch
          checkedChildren="On"
          unCheckedChildren="Off"
          checked={contactState.mustConfirm}
          onChange={value => {
            updateContactState({ mustConfirm: value });
          }}
        />{' '}
        <Text strong>
          Require this person&apos;s approval on all appointments.
        </Text>
      </StyledSwitchContainer>
    </StyledContainer>
  );
};

export default MultiConfListing;

const StyledContainer = styled.div``;

const StyledSwitchContainer = styled.div`
  display: inline-grid;
  grid-template-columns: auto 1fr;
  width: auto;
`;
